/* eslint-disable no-undef */
document.addEventListener("DOMContentLoaded", function () {
  // console.log("This is a testing provisioning alert. Please ignore.");
  // Initialization of the sub menu container and the breadcrumb links.
  const navLinks = document.querySelectorAll(".breadcrumb-links a")
  const subMenuContainer = document.querySelector(".navigational-sub-menu-container")
  const subMenuLists = subMenuContainer.querySelectorAll("ul")
  navLinks.forEach((link) => {
    // Matching the primary navigation menu to any sub menus that are added in the templates and creating a relationship between them. Also moves the sub menus of that into containers inside navigational-sub-menu-container.
    const formattedText = link.innerText.toLowerCase().replace(/\s+/g, "-")
    subMenuLists.forEach((subMenu) => {
      if (subMenu.id === formattedText) {
        link.closest("li").classList.add("match-found")
        const primarySubNav = document.createElement("div")
        primarySubNav.className = "primarysubnavigation"
        subMenu.appendChild(primarySubNav)
        const secondarySubNav = document.createElement("div")
        secondarySubNav.className = "secondarysubnavigation"
        subMenu.appendChild(secondarySubNav)
        const subMenuItems = subMenu.querySelectorAll("ul.sub-menu")
        // Appending a span svg of an arrow to the primary sub navigation menu items that have a sub menu.
        subMenuItems.forEach((subMenuItem) => {
          const siblingNavLink = subMenuItem.previousElementSibling
          if (siblingNavLink && siblingNavLink.classList.contains("nav-link")) {
            siblingNavLink
              .closest("li")
              .setAttribute("data-source", siblingNavLink.innerText.trim())
            subMenuItem.setAttribute("data-relation", siblingNavLink.innerText.trim())
          }
        })
        subMenuItems.forEach((subMenuItem) => {
          if (subMenuItem.hasAttribute("data-relation")) {
            secondarySubNav.appendChild(subMenuItem)
          }
        })
        const remainingItems = subMenu.querySelectorAll(":scope > li:not(.match-found)")
        remainingItems.forEach((item) => {
          primarySubNav.appendChild(item)
        })
      }
    })
  })
  // On hover of the primary navigation menu, show the sub menu container and set the active status of the inner items.
  navLinks.forEach((link) => {
    link.addEventListener("mouseover", function () {
      const formattedText = this.innerText.toLowerCase().replace(/\s+/g, "-")
      // console.log(formattedText)
      subMenuLists.forEach((subMenu) => {
        if (subMenu.id === formattedText) {
          subMenuContainer.style.display = "grid"
          subMenu.setAttribute("active-submenu", "true")
          const matchFoundLink = document.querySelector(".breadcrumb-links li.match-found")
          if (matchFoundLink) {
            matchFoundLink.classList.add("stay-active-submenu")
          }
        }
      })
    })
  })
  // Matching the primary subnavigation menu to any sub menus that are added in the templates and creating a relationship between them.
  const primarySubNavItems = document.querySelectorAll(".primarysubnavigation > li")
  primarySubNavItems.forEach((item) => {
    item.addEventListener("mouseover", function () {
      if (item.hasAttribute("data-source")) {
        const dataSourceValue = item.getAttribute("data-source")
        item.classList.add("stay-active")
        // console.log("Data-source value:", dataSourceValue)
        const secondarySubNavItems = document.querySelectorAll(".secondarysubnavigation > ul")
        secondarySubNavItems.forEach((secondaryItem) => {
          if (
            secondaryItem.hasAttribute("data-relation") &&
            secondaryItem.getAttribute("data-relation").trim().toLowerCase() ===
            dataSourceValue.trim().toLowerCase()
          ) {
            // console.log("Matching secondary item found:", secondaryItem)
            secondaryItem.classList.add("association-submenu-hover")
          }
        })
      }
    })
    // Ensure active status is removed when mouse enters a sibling item in primary sub navigation menu (left side) while also removing the secondary sub navigation display status.
    item.addEventListener("mouseover", function () {
      const activeItems = document.querySelectorAll(".primarysubnavigation > li.stay-active")
      activeItems.forEach((activeItem) => {
        if (activeItem !== item) {
          activeItem.classList.remove("stay-active")
          const secondarySubNavItems = document.querySelectorAll(".secondarysubnavigation > ul")
          secondarySubNavItems.forEach((secondaryItem) => {
            secondaryItem.classList.remove("association-submenu-hover")
          })
        }
      })
    })
  })
})
const listItemsWithLinks = document.querySelectorAll(".breadcrumb-links li")
listItemsWithLinks.forEach((link) => {
  const parentLi = link.closest("a")
  if (parentLi) {
    parentLi.addEventListener("click", function (event) {
      event.stopPropagation()
      link.click()
    })
  }
})
// Removal of the sub menu container on click outside of the menu in addition to removing the toggle active status of the inner items.
document.addEventListener("click", (event) => {
  const navSubMenuContainer = document.querySelector(".navigational-sub-menu-container")
  if (navSubMenuContainer && navSubMenuContainer.style.display === "grid") {
    const isClickInside = navSubMenuContainer.contains(event.target)
    if (!isClickInside) {
      navSubMenuContainer.style.display = "none"
      const allListItems = document.querySelectorAll("li")
      allListItems.forEach((li) => {
        li.classList.remove("stay-active")
        li.classList.remove("stay-active-submenu")
      })
    }
  }
})
// DBA mapping and interpolation replacement in strings
function dbaStringsInterpolation() {
  const currentdomainURL = window.location.hostname
    .replace(/^www\./, "")
    .replace(/^https?:\/\//, "")
  let matchedDba = null
  const domainMapping = {
    "AnnieMac Home Mortgage": [
      "local.annie-mac.com",
      "annie-mac.com",
      "anniemac.wpenginepowered.com",
      "anniemacdev.wpenginepowered.com",
      "anniemacstg.wpenginepowered.com",
    ],
    "OVM with AnnieMac Home Mortgage": [
      "ovmfinancial.com",
      "anniemac.wpengine.com",
      "anniemacdev.wpengine.com",
      "anniemacstg.wpengine.com",
    ],
    "Unify Home Lending": ["myunify.com"],
  }
  for (const [dba, domains] of Object.entries(domainMapping)) {
    if (domains.includes(currentdomainURL)) {
      matchedDba = dba
      break
    }
  }
  if (matchedDba) {
    document.querySelectorAll("p, h1, h2, h3, h4, h5, h6, li, span").forEach((el) => {
      if (el.textContent.includes("{{dba}}")) {
        el.textContent = el.textContent.replace(/{{dba}}/g, matchedDba)
      }
    })
  }
}
document.addEventListener("DOMContentLoaded", dbaStringsInterpolation)
// Initialization of the cookie to be used for the loan officer data.
function setCookieWithExpiration(name, value, days) {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = "expires=" + date.toUTCString()
  document.cookie = `${name}=${value}; ${expires}; path=/`
}
function getCookieByName(name) {
  const decodedCookies = decodeURIComponent(document.cookie)
  const cookiesArray = decodedCookies.split(";")

  for (let cookie of cookiesArray) {
    cookie = cookie.trim()
    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1)
    }
  }
  return null
}
function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}
let addLoURLHash = false
const unassociatedHeart = document.getElementById("unassociated-heart")
const cookiedHeart = document.getElementById("cookied-heart")
function getLoanOfficerData() {
  let storedData = getCookieByName("loan-officer-info")
    ? JSON.parse(getCookieByName("loan-officer-info"))
    : null

  const urlParams = new URLSearchParams(window.location.search)
  // Association logic for use cases to the loan officer data.
  if (urlParams.get("reassign_lo") === "true") {
    localStorage.removeItem("returnImmediately")
    localStorage.removeItem("returnLocation")
    const url = new URL(window.location.href)
    url.search = ""
    window.history.replaceState({}, document.title, url.toString())
  }
  if (
    urlParams.get("associate") === "true" ||
    window.location.href.includes("#associate=true") ||
    window.location.href.includes("landing-page&team") ||
    window.location.href.includes("landing-page&branch")
  ) {
    storedData = null
    if (localStorage.getItem("returnImmediately") === "true") {
      const returnLocation = localStorage.getItem("returnLocation")
      if (returnLocation) {
        localStorage.setItem("associatefrompagepath", "true")
        // console.log("Associated from page path?:", localStorage.getItem("associatefrompagepath"))
        window.location.href = `${returnLocation}`
        // window.location.href = `${returnLocation}?reassign_lo=true`
        localStorage.removeItem("returnImmediately")
        localStorage.removeItem("returnLocation")
      }
    }
  }
  const loanOfficerDataDefined = typeof loanOfficerData !== "undefined"
  if (loanOfficerDataDefined) {
    addLoURLHash = !loanOfficerData?.loan_officer?.on_post_page
    if (
      (loanOfficerData?.loan_officer?.update_needed &&
        loanOfficerData?.loan_officer?.on_post_page &&
        !storedData) ||
      (loanOfficerData?.loan_officer?.update_needed && !loanOfficerData?.loan_officer?.on_post_page)
    ) {
      delete loanOfficerData["loan_officer"]["update_needed"]
      delete loanOfficerData["loan_officer"]["on_post_page"]
      setCookieWithExpiration("loan-officer-info", JSON.stringify(loanOfficerData), 365)
      return loanOfficerData
    }
  }
  if (storedData) {
    try {
      if (!loanOfficerDataDefined) {
        addLoURLHash = !storedData?.loan_officer?.on_post_page
      }
      return storedData
    } catch (error) {
      console.error("Error parsing loan officer data from cookie:", error)
    }
  }
  return null
}
// Associate and create a cookie when favoriting the loan officer manually.
document.querySelector("#unassociated-heart")?.addEventListener("click", (e) => {
  e.preventDefault()
  delete loanOfficerData["loan_officer"]["update_needed"]
  delete loanOfficerData["loan_officer"]["on_post_page"]
  setCookieWithExpiration("loan-officer-info", JSON.stringify(loanOfficerData), 365)
  updateStickyNavLOData(loanOfficerData, false)
})

document.querySelector("#c2keys_call")?.addEventListener("click", (e) => {
  e.preventDefault()
  delete loanOfficerData["loan_officer"]["update_needed"]
  delete loanOfficerData["loan_officer"]["on_post_page"]
  setCookieWithExpiration("loan-officer-info", JSON.stringify(loanOfficerData), 365)
  updateStickyNavLOData(loanOfficerData, false)

  // Get data-src value and redirect if present
  const src = e.currentTarget.getAttribute("data-src")
  if (src) {
    window.location.href = src.startsWith("/") ? src : "/" + src
  }
})

const loanOfficerDataParsed = getLoanOfficerData()
if (loanOfficerDataParsed) {
  updateStickyNavLOData(loanOfficerDataParsed, addLoURLHash)
}
if (window.location.href.includes("initassign=true")) {
  const currentURL = localStorage.getItem("currentURL")
  if (currentURL) {
    window.location.href = currentURL
  }
}

if (localStorage.getItem("noassociation") !== null) {
  console.log(
    'Not accepting LO associations with:', localStorage.getItem("noassociation")
  );
}
if (typeof loanOfficerData === "undefined") {
  const urlHash = window.location.href.split("#lo=")[1]
  if (
    urlHash &&
    localStorage.getItem("associatefrompagepath") !== "true" &&
    localStorage.getItem("noassociation") !== urlHash &&
    (
      !document.querySelector("[data-global-id='associated-loan-originator-nmls']") ||
      document
        .querySelector("[data-global-id='associated-loan-originator-nmls']")
        .innerText.trim() === ""
    )
  ) {
    // console.log("loanOfficerData is undefined and #lo= is present in URL.")
    const returnLocation = window.location.href
    localStorage.setItem("returnLocation", returnLocation)
    const refValue = urlHash
    const rootUrl = window.location.origin
    const gotoassociate = `${rootUrl}/lo/${refValue}/?associate=true`
    // console.log(gotoassociate)
    localStorage.setItem("returnImmediately", "true")
    // console.log("returnLocation:", localStorage.getItem("returnLocation"))
    // console.log("returnImmediately:", localStorage.getItem("returnImmediately"))
    window.location.href = gotoassociate
  } else if (window.location.href.includes("?ressigned=true")) {
    localStorage.removeItem("associatefrompagepath")
  }
}
function updateStickyNavLOData(loanOfficerData, addLoURLHash) {
  if (!loanOfficerData || !loanOfficerData.loan_officer) {
    // console.warn("Invalid loan officer data or empty generate_website. Skipping update.")
    return
  }
  // Association of the loan officer data to the cookie data.
  const {
    permalink,
    first_name,
    last_name,
    nmls,
    tmp_shape_instance_id,
    shape_user_id,
    phone_office,
    phone_mobile,
    display_branch,
    mobile_app_link,
    bookings_url,
    sub_branch,
    address1,
    address2,
    city,
    state,
    zip,
    licensed_states,
    generate_website,
    $c2kprio_field,
  } = loanOfficerData.loan_officer
  console.log(loanOfficerData.loan_officer);
  let cookiedURL = loanOfficerData.loan_officer.permalink
  // console.log(cookiedURL);
  // console.log(loanOfficerData.loan_officer.bookings_url);
  if (
    loanOfficerData.loan_officer.generate_website &&
    loanOfficerData.loan_officer.generate_website !== "0" &&
    loanOfficerData.loan_officer.generate_website !== "N/A"
  ) {
    deleteCookie("loan-officer-info")
    // console.warn("Cookie removed due to generate_website being set and not 0 or N/A.")
    return
  }
  if (localStorage.getItem("noassociation")) {
    localStorage.removeItem("noassociation");
  }
  if (licensed_states && typeof licensed_states === "string") {
    const stateAbbrToName = {
      AL: "Alabama", AK: "Alaska", AZ: "Arizona", AR: "Arkansas", CA: "California",
      CO: "Colorado", CT: "Connecticut", DC: "District of Columbia", DE: "Delaware",
      FL: "Florida", GA: "Georgia", HI: "Hawaii", ID: "Idaho", IL: "Illinois",
      IN: "Indiana", IA: "Iowa", KS: "Kansas", KY: "Kentucky", LA: "Louisiana",
      ME: "Maine", MD: "Maryland", MA: "Massachusetts", MI: "Michigan",
      MN: "Minnesota", MS: "Mississippi", MO: "Missouri", MT: "Montana",
      NE: "Nebraska", NV: "Nevada", NH: "New Hampshire", NJ: "New Jersey",
      NM: "New Mexico", NY: "New York", NC: "North Carolina", ND: "North Dakota",
      OH: "Ohio", OK: "Oklahoma", OR: "Oregon", PA: "Pennsylvania", RI: "Rhode Island",
      SC: "South Carolina", SD: "South Dakota", TN: "Tennessee", TX: "Texas",
      UT: "Utah", VT: "Vermont", VA: "Virginia", WA: "Washington",
      WV: "West Virginia", WI: "Wisconsin", WY: "Wyoming"
    };
    const abbrs = licensed_states.replace(/"/g, "").split(",").map(s => s.trim()).filter(Boolean);
    const stateMap = {};
    abbrs.forEach(abbr => {
      if (stateAbbrToName[abbr]) {
        stateMap[abbr] = stateAbbrToName[abbr];
      }
    });
    console.log("Loan Originator Licensed States:", stateMap);
  }
  // Comparing the current hash URL to the expected has URL of the associated loan officer. Will force redirect if the hash does not match and force the user to associate to the loan officer when visiting that page.
  const currentHash = window.location.href.split("#lo=")[1]
  const expectedHash = `${first_name.toLowerCase()}${last_name.toLowerCase()}`
  // console.log("Current Hash:", currentHash)
  // console.log("Expected Hash:", expectedHash)
  if (
    currentHash &&
    currentHash !== expectedHash
    // localStorage.getItem("associatefrompagepath") !== "true"
  ) {
    // console.log("Current hash does not match expected hash. Redirecting to associate page.")
    const returnLocation = window.location.href.split("#")[0]
    localStorage.setItem("returnLocation", returnLocation)
    const refValue = currentHash
    localStorage.setItem("returnImmediately", "true")
    window.location.href = `/lo/${refValue}/?associate=true`
  }
  if (addLoURLHash) {
    const newHash = `lo=${first_name.toLowerCase()}${last_name.toLowerCase()}`;
    if (window.location.hash !== `#${newHash}`) {
      history.replaceState(null, "", `${window.location.pathname}${window.location.search}#${newHash}`);
    }
  }
  const associatedLoanOfficerName = document.querySelector(
    "[data-global-id='associated-loan-originator-name']"
  )
  if (associatedLoanOfficerName) {
    const menuItem = document.querySelector("#menu-item-8478")
    if (menuItem) {
      menuItem.remove()
    }
    let trimmedPermalink = permalink
    const loIndex = permalink.indexOf("/lo/")
    if (loIndex !== -1) {
      trimmedPermalink = permalink.substring(loIndex)
    }
    associatedLoanOfficerName.innerHTML = `<a href="${trimmedPermalink}">${first_name} ${last_name}</a>`
    associatedLoanOfficerName.setAttribute(
      "data-shape-instance",
      tmp_shape_instance_id?.trim() &&
        tmp_shape_instance_id !== "0" &&
        tmp_shape_instance_id !== "N/A"
        ? tmp_shape_instance_id
        : sub_branch?.shape_instance_id || ""
    )
    associatedLoanOfficerName.setAttribute("data-shape-user-id", shape_user_id || "")
    associatedLoanOfficerName.setAttribute("data-apply-link", mobile_app_link || "")
    const applyNowOverride = document.querySelector("#apply-now-override")
    if (applyNowOverride) {
      applyNowOverride.href = mobile_app_link || "#"
    }
  }
  const addressFooterLine1 = document.getElementById("addressfooter_line_1_override")
  const addressFooterCityStateZip = document.getElementById("addressfooter_city_state_zip_override")
  const phoneFooterOverride = document.getElementById("phonefooter_override")
  if (addressFooterLine1) {
    addressFooterLine1.textContent = `${address1 || ""} ${address2 || ""}`.trim()
  }
  if (addressFooterCityStateZip) {
    addressFooterCityStateZip.textContent = `${city || ""}, ${state || ""} ${zip || ""}`.trim()
  }
  if (phoneFooterOverride) {
    phoneFooterOverride.textContent =
      phone_office !== "N/A" && phone_office ? phone_office : phone_mobile || ""
  }
  const associatedLoanOfficerNMLS = document.querySelector(
    "[data-global-id='associated-loan-originator-nmls']"
  )
  if (associatedLoanOfficerNMLS) {
    associatedLoanOfficerNMLS.textContent = "NMLS# " + nmls
  }
  const associatedLoanOfficerPhone = document.querySelector(
    "[data-global-id='associated-loan-originator-phone']"
  )
  const associatedLoanOfficerPortrait = document.querySelector(
    "[data-global-id='associated-loan-originator-portrait']"
  )
  // Loading in of loan officer headshot photo if found to be a loadable URL.
  if (associatedLoanOfficerPortrait && loanOfficerData.loan_officer.nmls) {
    const headshotURL = `https://amweb.azureedge.net/amweb_headshots/${loanOfficerData.loan_officer.nmls}_compressed.webp`
    // console.log(headshotURL)
    const img = new Image()
    img.onload = () => {
      // console.log("Image loaded successfully:", headshotURL)
      img.alt = `${loanOfficerData.loan_officer.first_name} ${loanOfficerData.loan_officer.last_name}`
      associatedLoanOfficerPortrait.style.display = "flex"
      associatedLoanOfficerPortrait.appendChild(img)
    }
    img.onerror = () => {
      console.error("Error loading image:", headshotURL)
    }
    img.src = headshotURL
  }
  if (associatedLoanOfficerPhone) {
    associatedLoanOfficerPhone.textContent = phone_office !== "N/A" ? phone_office : phone_mobile
  }
  const associatedLoanOfficerBranch = document.querySelector(
    "[data-global-id='associated-loan-originator-branch']"
  )
  if (associatedLoanOfficerBranch) {
    if (
      loanOfficerData.loan_officer.bookings_url &&
      loanOfficerData.loan_officer.bookings_url.trim() !== ""
    ) {
      associatedLoanOfficerBranch.innerHTML = `<a href="${bookings_url}" target="_blank">Book Time</a>`
    } else {
      associatedLoanOfficerBranch.textContent = display_branch?.visual_name || "N/A"
    }
  }
  if (
    loanOfficerData.loan_officer.c2kprio_field &&
    loanOfficerData.loan_officer.c2kprio_field === "Prominent"
  ) {
    // Add a "Cash2Keys" menu item after the "Careers" menu item if it doesn't already exist
    const productMenuItem = document.querySelector("#menu-item-32013")
    if (productMenuItem && !document.getElementById("menu-item-cash2keys")) {
      const cash2KeysMenuItem = document.createElement("li")
      cash2KeysMenuItem.id = "menu-item-cash2keys"
      cash2KeysMenuItem.className =
        "menu-item menu-item-type-custom menu-item-object-page menu-item-cash2keys"
      const cash2KeysLink = document.createElement("a")
      cash2KeysLink.href = "/cash2keys"
      cash2KeysLink.className = "nav-link cash2keys-link"
      cash2KeysLink.textContent = "Cash2Keys"
      cash2KeysMenuItem.appendChild(cash2KeysLink)
      productMenuItem.parentNode.insertBefore(cash2KeysMenuItem, productMenuItem.nextSibling)
    }
  }
  if (loanOfficerData.loan_officer.c2kprio_field === "NoMastermind") {
    const c2kCta = document.querySelector(".cash2keys-realtor-cta")
    if (c2kCta) {
      c2kCta.style.visibility = "hidden"
      c2kCta.style.maxHeight = "0px"
      c2kCta.style.paddingTop = "0px"
    }
  }
  // Setting of the expected DBA relative to the loan officer associated and navigating the enduser to that URL if not on /lo/ or on testing domains.
  localStorage.setItem(
    "expected_dba_association",
    loanOfficerData.loan_officer.display_branch.dba_declaration
  )
  if (localStorage.getItem("expected_dba_association")) {
    const expectedDBA = localStorage.getItem("expected_dba_association")
    const dbaDomainMap = {
      AnnieMac: [
        "annie-mac.com",
        "anniemac.wpenginepowered.com",
        "anniemacdev.wpenginepowered.com",
        "anniemacstg.wpenginepowered.com",
      ],
      OVM: [
        "ovmfinancial.com",
        "anniemac.wpengine.com",
        "anniemacdev.wpengine.com",
        "anniemacstg.wpengine.com",
      ],
      Unify: ["myunify.com"],
    }
    const expectedDomains = dbaDomainMap[expectedDBA] || []
    console.log("Expected DBA Association:", expectedDBA)
    const currentHostname = window.location.hostname
      .replace(/^www\./, "")
      .replace(/^local\.annie-mac\.com$/, "annie-mac.com")
    if (
      expectedDomains.length > 0 &&
      !expectedDomains.includes(currentHostname) &&
      !window.location.pathname.startsWith("/lo/") &&
      !(
        (currentHostname === "local.annie-mac.com" && window.location.protocol === "http:") ||
        (currentHostname === "localhost" && window.location.protocol === "http:")
      )
    ) {
      const targetDomain = expectedDomains[0]
      const protocol = window.location.protocol
      const newUrl = `${protocol}//${targetDomain}${window.location.pathname}${window.location.search}${window.location.hash}`
      deleteCookie("loan-officer-info")
      localStorage.clear()
      window.location.href = newUrl
      return
    }
  }
  // Replacing of the logo in the navigation bar with the branded logo of the loan officer's team or branch team name associated to them.
  if (
    !document.body.classList.contains("branch-page") &&
    !document.body.classList.contains("loan-officer-page") &&
    !document.body.classList.contains("team-page")
  ) {
    if (
      loanOfficerData.loan_officer.lo_team_logo ||
      loanOfficerData.loan_officer.sub_branch?.team_visual_name_logo
    ) {
      const primaryPageLogo = document.querySelector("#primary-page-logo > svg")
      if (primaryPageLogo) {
        const logoAssetURLteam = loanOfficerData.loan_officer.lo_team_logo
          ? `${loanOfficerData.loan_officer.lo_team_logo.replace("/var/www/html/", "")}`
          : `${loanOfficerData.loan_officer.sub_branch.team_visual_name_logo.replace("/var/www/html/", "")}`
        if (logoAssetURLteam) {
          fetch(logoAssetURLteam)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok")
              }
              return response.text()
            })
            .then((svgText) => {
              primaryPageLogo.remove()
              const logoSvg = new DOMParser()
                .parseFromString(svgText, "image/svg+xml")
                .querySelector("svg")
              document.querySelector("#primary-page-logo").appendChild(logoSvg)
              document
                .querySelector("#primary-page-logo")
                .setAttribute(
                  "title",
                  `You're associated with ${loanOfficerData.loan_officer.first_name} ${loanOfficerData.loan_officer.last_name} from ${loanOfficerData.loan_officer.lo_team !== "N/A" ? loanOfficerData.loan_officer.lo_team : loanOfficerData.loan_officer.sub_branch?.team_visual_name}, so their logo is displaying here.`
                )
            })
            .catch((error) => console.error("Error fetching SVG:", error))
        }
      }
    }
  }
  // Application of the loan officer information to the association bar and toggling of the active status of the bar if valid information.
  if (
    associatedLoanOfficerName ||
    associatedLoanOfficerPhone ||
    associatedLoanOfficerBranch ||
    associatedLoanOfficerHeadshot
  ) {
    const associationBar = document.querySelector(".loan-officer-association-bar-wrp")
    associationBar?.classList.add("active")
  }
}
const disassociationAction = document.querySelector(
  "[data-global-id='loan-officer-disassociation']"
)
const disassociationPopup = document.querySelector(
  "[data-global-id='disassociation-popover-announcement']"
)
const disassociationInsidePopup = document.querySelector(
  "[data-global-id='outer-disassociation-popover-announcement']"
)
// When removing association of loan loanOfficerDataParsed, clear local storage, delete cookies and return to current UR
disassociationAction.addEventListener("click", () => {
  deleteCookie("loan-officer-info")
  localStorage.clear()
  const checkLOhashstring = window.location.hash.replace(/^#lo=/, "");
  if (checkLOhashstring) {
    localStorage.setItem("noassociation", checkLOhashstring);
    console.log("Disassociated LO hash string:", checkLOhashstring);
  }
  for (let i = 0; i < 3; i++) {
    if (window.location.hash) {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  }
  window.location.reload();
})

document.addEventListener("DOMContentLoaded", () => {
  const loFavorite = document.querySelector(".lo-favorite")
  if (loFavorite) {
    const inactiveElements = loFavorite.querySelectorAll(".active-status-false")
    inactiveElements.forEach((element) => element.remove())
  }
})
// Onclick of remove storage items, always clear local storage.
const removeStorageElements = document.querySelectorAll('[data-action="remove_storage"]')
if (removeStorageElements.length > 0) {
  removeStorageElements.forEach(function (element) {
    element.addEventListener("click", function () {
      localStorage.clear()
    })
  })
}
// Adjust adminbar height to accommodate the association bar flexing.
document.addEventListener("DOMContentLoaded", () => {
  const wpadminbar = document.getElementById("wpadminbar")
  if (wpadminbar) {
    document.body.insertBefore(wpadminbar, document.body.firstChild)
    const adjustMarginTop = () => {
      const wpadminbarHeight = wpadminbar.offsetHeight
      document.body.style.marginTop = wpadminbarHeight + "px"
    }
    adjustMarginTop()
    window.addEventListener("resize", adjustMarginTop)
  }
})
